import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTE_CONSTANTS } from 'constants/util/route-constants';

const TieoutPage = () => <Navigate to={ROUTE_CONSTANTS.HOME_PAGE} replace />;

export default TieoutPage;
